import API from 'utils/api';
import { logger } from 'utils/debug';
import { onSuccess, onError } from 'utils/handlers';
import { tipoDeDocumentoExpedienteEnum } from 'views/Tramites/GPM/enums';

export const baseURI = 'tramites/expedientes-de-tramites/';

const filesToSearch = [
  {
    tipo: tipoDeDocumentoExpedienteEnum.FOTOGRAFIA,
    name: '__foto__',
  },
  {
    tipo: tipoDeDocumentoExpedienteEnum.GIS,
    name: '__base64croquis__',
  },
];

export const expedienteToAttrs = (expediente) => {
  const attrs = {};
  filesToSearch.forEach((f) => {
    const url = expediente.findLast((e) => e.tipo_de_documento_para_expediente === f.tipo)?.archivo;
    if (url) {
      attrs[f.name] = url;
    }
  });
  return attrs;
};

/**
 * GET Expedientes De Tramites
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getExpedientesDeTramites = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Expediente De Tramite
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getExpedienteDeTramite = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

const formatFileValues = (_values) => {
  const values = { ..._values };
  const formData = new FormData();
  const valuesKeys = Object.keys(values);
  valuesKeys.forEach((key) => {
    formData.append(key, values[key] || '');
  });
  formData.append('tamanio', (values.archivo.size / 1024 / 1024).toFixed(2));
  formData.append('extension_del_documento', values.archivo.name.split('.').pop().toLowerCase());

  const _config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  return [formData, _config];
};

/**
 * POST Expediente De Tramite
  * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const postExpedienteDeTramite = async (_values) => {
  try {
    const [values, config] = formatFileValues(_values);
    if (!parseFloat(values.get('tamanio'))) {
      // eslint-disable-next-line no-console
      logger('[_values]', _values);
      throw new Error('Ah ocurrido un error, adjunte el archivo de nuevo o intentelo más tarde');
    }
    const response = await API.post(baseURI, values, config);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * PATCH Expediente De Tramite
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchExpedienteDeTramite = async (id, _values) => {
  try {
    const [values, config] = formatFileValues(_values);
    const response = await API.patch(`${baseURI}${id}`, values, config);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * DELETE Expediente De Tramite
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteExpedienteDeTramite = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
